import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRootssageComponent } from './simple-icons-rootssage.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRootssageComponent ],
    exports:      [ SimpleIconsRootssageComponent ],
    bootstrap:    []
})
export class SimpleIconsRootssageModule {}
